
'use strict';

import React, {PropTypes} from 'react';

export default function EditJobIcon(props) {

  const {
    className,
		color,
    ...otherProps
  } = props;

	const defaultColor = '#333333';

  return (
    <svg width="18px" height="22px" viewBox="0 0 18 22" version="1.1" xmlns="http://www.w3.org/2000/svg" className={`profile-icon ${className}`} {...otherProps}>
		<g id="2471---HR---Job-Request-Table-EditIcon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<g transform="translate(-1210.000000, -222.000000)" id="Group-21" strokeWidth="1.5" stroke={color || defaultColor}>
				<g transform="translate(80.000000, 161.000000)">
					<g id="Group-17" transform="translate(990.000000, 0.000000)">
						<g id="Group-13" transform="translate(141.000000, 62.000000)">
							<polyline id="Shape" points="5.44 19.2 8.96 19.2 12.48 19.2 16 19.2 16 14.4 16 9.6 16 5.46688 10.74688 0 8.96 0 5.44 0 1.92 0 1.92 4.8 1.92 6.4"></polyline>
							<polyline id="Shape" points="10.24 0.64 10.24 5.76 15.36 5.76"></polyline>
							<polygon id="Shape" points="2.49408 17.42912 0 19.2 0.0992 16.11392 2.69248 11.25696 5.28512 6.4 6.48256 7.05728 7.68 7.71456 5.08672 12.57152"></polygon>
							<path d="M4.2176,8.62976 L6.36032,9.7472" id="Shape"></path>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>

  );

}



// WEBPACK FOOTER //
// ./shared/common/svgs/EditJobIcon.js